import { PATH_TO_COURSES_QUERY } from "../consts";

export function makeActionTypes(featureName: string) {
  return {
    RECEIVE_QUERY_RESULTS: `seneca/${featureName}/RECEIVE_QUERY_RESULTS`
  };
}

export default makeActionTypes(PATH_TO_COURSES_QUERY);
